import React from 'react';
import {EmojiDict} from "../../../../../gd/const/item-icon/emoji/emoji";
import {EntityType} from "../../../../../gd/const/item";
import GoalIconUI5, {GoalIconSize} from "../../../../../gd-components/icons/goal/goal-icon-ui5";
import CustomIcon from "../../../../../gd-components/icons/common/custom-icon/custom-icon";
import Emoji from "../../../../../gd-components/icons/common/emoji/emoji";
import {ItemIconClass} from "../../../../../gd/const/item-icon/icon/item-icon-class";
import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty";
import {ItemIconSize} from "../../../../../gd-components/icons/@const";

const debug = false
// const debug = "FieldIcon_ValueNotEmpty"

export default function FieldIcon_ValueNotEmpty(props: FieldEditableValueNotEmptyProps) {

    const classes = Classes(props.className, {
        "is-disabled": props.disabled
    })

    const renderIcon = ()=> {

        if (props.value?.substring(0, 4) === 'url:') {
            return <CustomIcon size={ItemIconSize.SIZE_16} className={props.className} icon={props.value}/>
        }

        if (!!EmojiDict[props.value]) {

            // need add black and white fiulter when disabled ?
            const classes = Classes(props.className)

            return <Emoji name={props.value} className={classes} size="16"/>
        }

        const iconClass = ItemIconClass[props.value]

        const iconClasses = Classes(iconClass, "ui5-ico-"+ItemIconSize.SIZE_16)

        return <div className={iconClasses}></div>
    }

    return (
        <>
            <div className  = {classes}
                 onClick    = {props.onClick}>
                {renderIcon()}
            </div>

            {props.children}
        </>
    )
}
